/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeSubscriptionEventBean', 'model/StripeSubscriptionEventObject'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeSubscriptionEventBean'), require('./StripeSubscriptionEventObject'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.StripeSubscriptionEventRequest = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.StripeSubscriptionEventBean, root.BpmbuildDevelopmentappspotcom.StripeSubscriptionEventObject);
  }
}(this, function(ApiClient, StripeSubscriptionEventBean, StripeSubscriptionEventObject) {
  'use strict';

  /**
   * The StripeSubscriptionEventRequest model module.
   * @module model/StripeSubscriptionEventRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionEventRequest</code>.
   * @alias module:model/StripeSubscriptionEventRequest
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionEventRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionEventRequest} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionEventRequest} The populated <code>StripeSubscriptionEventRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('api_version'))
        obj.apiVersion = ApiClient.convertToType(data['api_version'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('data'))
        obj.data = StripeSubscriptionEventObject.constructFromObject(data['data']);
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('livemode'))
        obj.livemode = ApiClient.convertToType(data['livemode'], 'Boolean');
      if (data.hasOwnProperty('object'))
        obj._object = ApiClient.convertToType(data['object'], 'String');
      if (data.hasOwnProperty('pending_webhooks'))
        obj.pendingWebhooks = ApiClient.convertToType(data['pending_webhooks'], 'Number');
      if (data.hasOwnProperty('stripeEventList'))
        obj.stripeEventList = ApiClient.convertToType(data['stripeEventList'], [StripeSubscriptionEventBean]);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} apiVersion
   */
  exports.prototype.apiVersion = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {module:model/StripeSubscriptionEventObject} data
   */
  exports.prototype.data = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Boolean} livemode
   */
  exports.prototype.livemode = undefined;

  /**
   * @member {String} _object
   */
  exports.prototype._object = undefined;

  /**
   * @member {Number} pendingWebhooks
   */
  exports.prototype.pendingWebhooks = undefined;

  /**
   * @member {Array.<module:model/StripeSubscriptionEventBean>} stripeEventList
   */
  exports.prototype.stripeEventList = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/StripeSubscriptionEventRequest.js